import { useStaticQuery, graphql } from 'gatsby';


/*
  This file is specifically for querying local JSON files via the Plugin gatsby-source-filesystem
  The Serverside Rendering process customizes many parts of pages, including header links, language,
  GTM Container, and other defaults. The per-page customization is largely driven by brand and region
  (Custom Fields like optinMonsterCampaignId can also be per-variant, though that is not Serverside).

  Static queries like this are compiled to text ahead of being executed. We can't dynamically merge
  in the region and brand for a `filter` request, so instead, we pull all the local brandRegionSettings data
  and filter it after the fact. The 'allDataJson' query specifically refers to the folder 'brandRegionSettings/data/'

  Also note: region is COUNTRY-LANG format, which is OPPOSITE the website's /lang/country/ url pathing
  This is to make it more readable when users select in the UI
  */

const useRegionData = (inputBrand, inputRegion) => {

  const data = useStaticQuery(
    graphql`
      {
        allDataJson {
          edges {
            node {
              brand
              region
              language
              domain
              tagContainerId
              defaultTitle
              defaultDescription
              copyrightText
              headerNavigation {
                title
                url
              }
              headerCTA {
                title
                url
              }
              footerLinks {
                title
                url
              }
              welcomeBannerUrl
            }
          }
        }
      }
    `
  );

  const regionData = data.allDataJson.edges.find(
    (row) => row.node.brand === inputBrand && row.node.region === inputRegion
  );
  return regionData.node;
};

export default useRegionData;
